import colors, { palette } from '../colors';
export default {
  primary: {
    container: {
      width: '100%'
    },
    input: {
      position: 'relative',
      width: '100%',
      height: 'auto',
      fontFamily: 'inherit',
      overflow: 'auto',
      padding: '0 15px',
      paddingBottom: '10px',
      resize: 'none',
      lineHeight: '22px',
      boxSizing: 'border-box',
      borderRadius: '4px',
      fontSize: '16px',
      border: 'none',
      outline: 'none'
    },
    wrapper: {
      border: "1px solid ".concat(palette.primary),
      borderRadius: '4px',
      transition: 'border 250ms'
    },
    label: {
      display: 'block',
      margin: '0 15px',
      paddingTop: '16px',
      paddingBottom: '6px',
      color: palette.primary,
      transition: 'color 250ms'
    },
    labelActive: {
      color: palette.primary
    },
    placeholder: {
      color: colors.blueyGrey,
      lineHeight: '1.38',
      fontSize: '16px'
    },
    counter: {
      display: 'block',
      marginTop: '10px',
      fontSize: '12px',
      color: colors.bluishGrey
    }
  },
  "default": {
    container: {
      width: '100%'
    },
    input: {
      position: 'relative',
      width: '100%',
      height: 'auto',
      fontFamily: 'inherit',
      overflow: 'auto',
      padding: '0 15px',
      paddingBottom: '10px',
      resize: 'none',
      lineHeight: '22px',
      boxSizing: 'border-box',
      borderRadius: '4px',
      fontSize: '16px',
      border: 'none',
      outline: 'none'
    },
    wrapperActive: {
      border: "1px solid ".concat(palette.primary)
    },
    wrapper: {
      border: "1px solid ".concat(colors.cloudyBlue),
      borderRadius: '4px',
      transition: 'border 250ms'
    },
    label: {
      display: 'block',
      margin: '0 15px',
      paddingTop: '16px',
      paddingBottom: '6px',
      color: colors.bluishGrey,
      transition: 'color 250ms'
    },
    labelActive: {
      color: palette.primary
    },
    placeholder: {
      color: colors.blueyGrey,
      lineHeight: '1.38',
      fontSize: '16px'
    },
    counter: {
      display: 'block',
      marginTop: '10px',
      fontSize: '12px',
      color: colors.bluishGrey
    }
  },
  error: {
    container: {
      width: '100%'
    },
    input: {
      position: 'relative',
      width: '100%',
      height: 'auto',
      fontFamily: 'inherit',
      overflow: 'auto',
      padding: '0 15px',
      paddingBottom: '10px',
      resize: 'none',
      lineHeight: '22px',
      boxSizing: 'border-box',
      borderRadius: '4px',
      fontSize: '16px',
      border: 'none',
      outline: 'none'
    },
    wrapper: {
      border: "1px solid ".concat(palette.error),
      borderRadius: '4px'
    },
    label: {
      display: 'block',
      margin: '0 15px',
      paddingTop: '16px',
      paddingBottom: '6px',
      color: palette.error
    },
    placeholder: {
      color: colors.blueyGrey,
      lineHeight: '1.38',
      fontSize: '16px'
    },
    counter: {
      display: 'block',
      marginTop: '10px',
      fontSize: '12px',
      color: colors.bluishGrey
    },
    hint: {
      display: 'block',
      color: palette.error,
      marginTop: '10px',
      fontSize: '12px'
    }
  }
};